// 车牌正则
export const carNumReg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4,5}[A-Z0-9挂学警港澳]{0,1}$/;

// 手机号正则
export const phoneReg = /^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/;

// 金额正则（缴纳）
export const amountReg = /^(0|([1-9]\d{0,7}))(\.\d{1,2})?$/;

// 付款账户正则
export  const  accountReg = /^\d{10,20}$/

// 付款银行正则
export  const  bankReg = /^[\u4E00-\u9FA5]{4,30}$/

// 付款流水号
export  const  serialNumberReg = /^[a-zA-Z0-9]{5,40}$/

// 失败原因
export const failReasonReg =  /^.{1,100}$/



// WEBPACK FOOTER //
// ./src/hooks/regex.js